module.exports = __webpack_public_path__ + "img/selected4-min.cd20b664.png";